<!-- HTML -->
<template>
  <div>

    <section class="section hero is-fullheight">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-mobile">
            <div class="column is-3">
              <div class="scene-3d">
                <div class="level-3d left-side rotate-clockwise" ref="album">
                  <figure class="image is-square">
                    <transition
                      name="fade-l"
                      mode="out-in"
                    >
                      <img
                        v-bind:src="playlist.tracks[playlist.queue].albumartwork"
                        v-bind:key="playlist.queue"
                        alt=""
                      >
                    </transition>
                  </figure>
                </div>
              </div>
            </div>
            <div class="column is-8 is-offset-1">
              <div class="scene-3d">
                <div class="level-3d right-side rotate-counter-clockwise" ref="song">
                  <figure class="image is-3by2">
                    <transition
                      name="fade-r"
                      mode="out-in"
                    >
                      <img
                        v-bind:src="playlist.tracks[playlist.queue].songartwork"
                        v-bind:key="playlist.queue"
                        alt=""
                      >
                    </transition>
                  </figure>
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-8 is-offset-1 title-container">
              <transition
                name="fade-l"
                mode="out-in"
              >
                <h1
                  class="title is-1"
                  v-bind:key="playlist.queue"
                >
                    {{ playlist.tracks[playlist.queue].title }}
                </h1>
              </transition>
              <transition
                name="fade-r"
                mode="out-in"
              >
                <h1
                  class="title is-1 ghost-title"
                  v-bind:key="playlist.queue">
                    {{ playlist.tracks[playlist.queue].title }}
                </h1>
              </transition>
              <div id="audio-player">
                <audio ref="audioObject" v-bind:src="playlist.tracks[playlist.queue].mp3src" preload="auto"></audio>
                <div id="waveblock-container">
                  <div
                    v-for="(w, index) in playlist.tracks[playlist.queue].waves"
                    :key="index"
                    class="waveblock"
                  >
                    <div
                      class="waveblock-col"
                      v-bind:style="{
                        backgroundColor: waveblock.color,
                        height: waveblockHeight(index)
                      }"
                    ></div>
                  </div>
                  <div
                    id="cursor"
                    v-if="cursor.display"
                    v-bind:style="{ transform: cursor.position }"
                  ></div>
                </div>
                <div id="audio-buttons" class="buttons">
                  <figure class="image is-48x48">
                    <img
                      id="previous-button"
                      v-on:click="previousTrack"
                      v-bind:class="{ bounceButton: buttons.previous }"
                      src="../../assets/icons/audio-player/last-track-button-g.svg"
                      alt="Previous track button"
                    />
                  </figure>
                  <figure class="image is-48x48">
                    <img
                      id="play-pause-button"
                      v-on:click="playPauseTrack"
                      v-bind:class="{ rotateButton: cursor.playing }"
                      src="../../assets/icons/audio-player/play-button-g.svg"
                      alt="Play pause button"
                    />
                  </figure>
                  <figure class="image is-48x48">
                    <img
                      id="next-button"
                      v-on:click="nextTrack"
                      v-bind:class="{ bounceButton: buttons.next }"
                      src="../../assets/icons/audio-player/next-track-button-g.svg"
                      alt="Next track button"
                    />
                  </figure>
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-offset-1 lyrics">
              <div
                v-html="playlist.tracks[playlist.queue].lyrics"
              >
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<!-- JavaScript -->
<script>

import { playlist } from "../../assets/audio/playlist-full-length.js";

export default {

  name: "MusicAudio",

  data() {

    return {

      playlist: playlist, // Seed the playlist with the playlist file
      cursor: {
        display: false,
        playing: false,
        increment: 0,
        position: ""
      },
      waveblock: {
        increment: 0,
        incrementAmt: 0,
        incrementPos: 0,
        color: "#393e46" // Color is gray to start with, then becomes green when downloaded and available to play
      },
      buttons: {
        previous: false,
        next: false
      },

    };

  },

  methods: {

    // Initialize the heights of the waveblocks
    waveblockHeight(index) {
      let height =
        this.playlist.tracks[this.playlist.queue].waves[index] + "px";
      return height;
    },

    // Determine and set the amount of time in 1/10 of a second to change waveblock color
    initializeWaveblock() {
      let length = this.playlist.tracks[this.playlist.queue].length;
      let increment = length * (10 / 54); // ! Important !
      this.waveblock.incrementAmt = increment;
      this.waveblock.incrementAmtPos = increment;
    },

    changeWaveblockColor() {
      let wavelist = document.getElementsByClassName("waveblock-col");
      wavelist[this.waveblock.increment].style.backgroundColor = "#29a174";
      this.waveblock.increment++;
      this.waveblock.incrementAmtPos =
        this.waveblock.incrementAmtPos + this.waveblock.incrementAmt;
    },

    // Function that is run when the Play/Pause button is pressed
    playPauseTrack() {
      // Check if the the track is loaded
      if (this.playlist.tracks[playlist.queue].loaded == true) {
        this.cursor.display = true; // Display the cursor
        // Determine if it should play or pause the track
        if (this.cursor.playing) {
          this.pauseCursor(); // Pause the Cursor
          this.$refs.audioObject.pause(); // Pause the audio
        } else {
          this.startCursor(); // Start the Cursor
          this.$refs.audioObject.play(); // Play the audio
          // Only initialize the waveblock if the audio has not played yet
          if (this.waveblock.increment === 0) {
            this.initializeWaveblock();
          }
        }

      } // If the track is not ready, do nothing

    },

    // Start Cursor
    startCursor() {
      this.cursor.playing = true;
      // Set Interval to move Cursor every 1/10th of a second
      startCursorTimer = setInterval(this.moveCursor, 100);
    },

    // Stop Cursor
    stopCursor() {
      // Stop the timing interval
      clearInterval(startCursorTimer);
      this.cursor.display = false;
      this.cursor.playing = false;
      this.cursor.increment = 0;
      this.cursor.position = "";
      this.waveblock.increment = 0;
      this.waveblock.incrementAmt = 0;
      this.waveblock.incrementPos = 0;
      // Reset the color of all the waveblocks
      let col = document.getElementsByClassName("waveblock-col");
      for (let i = 0; i < col.length; i++) {
        col[i].style.backgroundColor = this.waveblock.color;
      }
    },

    pauseCursor() {
      this.cursor.playing = false;
      // Stop the timing interval
      clearInterval(startCursorTimer);
    },

    moveCursor() {
      // Variables
      let boundary = document.getElementById("waveblock-container").clientWidth - 40, // Get the container width
        trackLength = this.playlist.tracks[this.playlist.queue].length, // Get the track length and set it to a variable
        pxAmount = boundary / trackLength / 10, // Compute the amount of pixels to move per 1/10th of a second
        increment = this.cursor.increment, // +1 every 1/10th of a second
        txt = "translateX(" + pxAmount * increment + "px)";
      // Set Cursor position
      this.cursor.position = txt;
      // Check if interval matches waveblock
      if (
        this.cursor.increment === Math.floor(this.waveblock.incrementAmtPos)
      ) {
        this.changeWaveblockColor();
      }
      // Check if the track is done
      if (increment === trackLength * 10) {
        this.stopCursor();
      }
      // Set increase in increment
      this.cursor.increment++;
    },

    // Function that is run when the Previous button is pressed
    previousTrack() {
      // Reset audio load
      this.playlist.tracks[playlist.queue].loaded = false;
      // Click Animation
      this.buttons.previous = true; // Add click animation class
      // Remove click animation class after 500ms
      setTimeout( () => {
        this.buttons.previous = false;
      }, 500);
      // Playlist & Cursor
      if (this.cursor.increment === 0) {

        // Rotate Images
        this.rotateImages();

        let last = this.playlist.tracks.length - 1;
        let queue = this.playlist.queue;
        if (queue === 0) {
          this.playlist.queue = last;
        } else {
          this.playlist.queue--;
        }
        this.waveblock.color = '#393e46';
        this.trackLoadListener();
      } else {
        this.stopCursor();
        this.$refs.audioObject.pause();
        this.$refs.audioObject.currentTime = 0.0;
        this.playlist.tracks[playlist.queue].loaded = true;
      }
    },

    // Function that is run when the Next button is pressed
    nextTrack() {
      // Rotate Images
      this.rotateImages();
      // Reset audio load
      this.playlist.tracks[playlist.queue].loaded = false;
      this.waveblock.color = '#393e46';
      // Click Animation
      this.buttons.next = true; // Add click animation class
      // Remove click animation class after 500ms
      setTimeout( () => {
        this.buttons.next = false;
      }, 500);
      // Playlist & Cursor
      this.stopCursor();
      let last = this.playlist.tracks.length - 1;
      let queue = this.playlist.queue;
      if (queue === last) {
        this.playlist.queue = 0;
      } else {
        this.playlist.queue++;
      }
      this.trackLoadListener();
    },

    trackLoadListener() {
      // Listen for when track is loaded, then set it to true
      this.$refs.audioObject.addEventListener('canplaythrough', (event) => {
        this.playlist.tracks[playlist.queue].loaded = true;
        this.waveblock.color = "#71cdaa"; // Change waveblock color to green when available to play
      });
      // Hack that helps prevent bugs
      this.$refs.audioObject.load();
      // iOS Hack
      setTimeout( () => {
        if ( this.playlist.tracks[playlist.queue].loaded == false ) {
          this.playlist.tracks[playlist.queue].loaded = true;
          this.waveblock.color = "#71cdaa"; // Change waveblock color to green when available to play
        }
      }, 4000);
      // End iOS Hack
    },

    rotateImages() {

      if ( this.$refs.album.classList.contains('rotate-clockwise') == true ) {

        this.$refs.album.classList.remove('rotate-clockwise');
        this.$refs.album.classList.add('rotate-counter-clockwise');
        this.$refs.song.classList.remove('rotate-counter-clockwise');
        this.$refs.song.classList.add('rotate-clockwise');

      } else {

        this.$refs.album.classList.remove('rotate-counter-clockwise');
        this.$refs.album.classList.add('rotate-clockwise');
        this.$refs.song.classList.remove('rotate-clockwise');
        this.$refs.song.classList.add('rotate-counter-clockwise');

      }

    }

  },

  mounted() {

    this.trackLoadListener();

  },

  beforeDestroy() {

    this.stopCursor();

  }

};

// Apply multiplier to the playlist file
function applyMultiplier() {
  let multiplier = 64; // Determine max height of waveblocks in px
  let playlistLength = playlist.tracks.length;
  for (let i = 0; i < playlistLength; i++) {
    let waveLength = playlist.tracks[i].waves.length;
    for (let j = 0; j < waveLength; j++) {
      playlist.tracks[i].waves[j] = Math.ceil(
        playlist.tracks[i].waves[j] * multiplier
      );
    }
  }
}

var startCursorTimer; // Define a global scope for the Cursor Timer
applyMultiplier(); // Apply the multiplier to the playlist once

</script>

<!-- CSS -->
<style lang="scss" scoped>
@import "../../assets/scss/variables.scss";
@import "../../assets/scss/transitions.scss";

// Text
h1, h5 {
  font-family: "astera";
  color: $white-trans-1;
}
.section {
  overflow: hidden;
}
.ghost-title {
  position: absolute;
  top: -24px;
  left: -40px;
  font-size: 8rem;
  white-space: nowrap;
  color: $white-trans-3;
}

// Audio Player
#audio-player {
  position: relative;
  padding: 20px;
  height: 104px;
  background-color: rgba(0, 0, 0, 0.5);
}
#waveblock-container {
  position: absolute;
  width: 100%;
  padding: 20px;
  top: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
}
.waveblock {
  height: 64px;
  text-align: center;
  display: inline-block;
}
.waveblock div {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
@media screen and (max-width: 512px) {
  .waveblock div {
    width: 2px;
  }
}
@media all and (min-width: 513px) and (max-width: 640px) {
  .waveblock div {
    width: 3px;
  }
}
@media all and (min-width: 641px) and (max-width: 768px) {
  .waveblock div {
    width: 5px;
  }
}
@media all and (min-width: 769px) and (max-width: 896px) {
  .waveblock div {
    width: 6px;
  }
}
@media all and (min-width: 897px) and (max-width: 1024px) {
  .waveblock div {
    width: 7px;
  }
}
@media all and (min-width: 1025px) and (max-width: 1152px) {
  .waveblock div {
    width: 8px;
  }
}
@media all and (min-width: 1153px) and (max-width: 1280px) {
  .waveblock div {
    width: 10px;
  }
}
@media all and (min-width: 1281px) and (max-width: 1408px) {
  .waveblock div {
    width: 12px;
  }
}
@media all and (min-width: 1409px) {
  .waveblock div {
    width: 14px;
  }
}
#cursor {
  position: absolute;
  height: 64px;
  width: 1px;
  left: 0;
  bottom: 0;
  margin: 20px;
  background-color: $gray-tint-2;
}

// Buttons
#play-pause-button,
#previous-button,
#next-button {
  cursor: pointer;
}
#audio-buttons {
  position: relative;
  top: 100px;

  figure:nth-child(1) {
    margin-left: auto;
    margin-right: 0;
  }
  figure:nth-child(2) {
    margin: 0;
  }
  figure:nth-child(3) {
    margin-left: 0;
    margin-right: auto;
  }
}
.rotateButton {
  animation: rotation 8s infinite linear;
}
@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
.bounceButton {
  animation: bounceIn 0.5s ease-in-out 1;
}
@keyframes bounceIn {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.4);
  }
  50% {
    transform: scale(0.8);
  }
  75% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

@media screen and (max-width: 512px) {
  h1 {
    font-size: 1.8rem !important;
  }
  .ghost-title {
    font-size: 4rem !important;
    top: -4px;
  }
}

.section {
  padding: 10rem 0;
  background-color: $black;
}
.left-column {
  transform:translateX(1rem);
}
.right-column {
  transform:translateX(-1rem);
}
.title-container {
  position: relative;
  margin-top: 4rem;
}
.lyrics {
  margin-top: 4rem;
}

/* 3D */
.scene-3d {
  perspective: 60em; // Amount of depth
}
.level-3d {
  transition: transform 1.5s;
  transform-style: preserve-3d;
}
.rotate-clockwise {
  transform: rotateY(-18deg);
}
.rotate-counter-clockwise {
  transform: rotateY(18deg);
}
.z-bot {
  z-index: 1;
}
.z-top {
  z-index: 2;
}

</style>

<!-- Unscoped CSS -->
<style>
 p {
   padding-bottom: 1rem;
 }
</style>
